import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import { IntegrationsMapping } from "../IntegrationsMapping";
import IntegrationTypeBackButton from "./IntegrationBackButton";

const IntegrationPage = () => {
  const { integrationName } = useParams();
  return (
    <>
      <Box ml="20px" mt="20px">
        <IntegrationTypeBackButton name={integrationName} />
      </Box>
      {IntegrationsMapping[integrationName].component}
    </>
  );
};

export default IntegrationPage;
